
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import GalaLogoIcon from '~/components/SvgIcons/GalaLogoIcon.vue';

@Component({
  components: {
    GalaLogoIcon,
  },
})
export default class SaleItemPrice extends Vue {
  @Prop(String) readonly price!: string;
  @Prop(String) readonly symbol!: string;
  @Prop(Number) readonly discount!: number;
  @Prop(Number) readonly usdPrice!: number;
  @Prop(String) readonly title!: string;

  get formattedPrice() {
    return this.price ? this.formatPrice(this.price, this.symbol) : undefined;
  }

  get formattedUsdPrice() {
    return this.usdPrice
      ? this.formatPrice(`${this.usdPrice / 100}`, '$')
      : undefined;
  }

  get priceA11yLabel() {
    if (!this.price) {
      return undefined;
    }
    const amount = this.formattedPrice;
    const usdAmount = this.formattedUsdPrice;
    return this.isCreditCard(this.symbol)
      ? this.$t('components.films.filmItemForSale.a11yPriceTextFiat', {
          title: this.title,
          amount,
        })
      : usdAmount !== undefined
      ? this.$t('components.films.filmItemForSale.a11yPriceText', {
          amount,
          usdAmount,
          symbol: this.symbol,
          title: this.title,
        })
      : this.$t('components.films.filmItemForSale.a11yPriceTextCrypto', {
          amount,
          symbol: this.symbol,
          title: this.title,
        });
  }

  isCreditCard = (symbol: string) => {
    return symbol && symbol.startsWith('CC');
  };

  coinIcon(coin: string) {
    const symbol = coin || this.symbol;
    if (!symbol) {
      return '';
    }

    try {
      return require(`@/assets/logos/${symbol}-icon.png`);
    } catch (e) {
      return '';
    }
  }

  formatPrice(price: string, symbol: string) {
    const highPrice = +price >= 1000000;
    let format = '0,0';

    if (symbol !== 'GALA' || highPrice) {
      format += '[.]0[00]';
    }

    if (highPrice) {
      format += ' a';
    }

    return this.$options.filters?.formatNumber(+price, format) || `${+price}`;
  }
}
